import styled from 'styled-components/macro';
import { colourPrimaryDarkPurple } from '../../../styling/colours';
import { DataForDesignDrawingsManifold } from './dataForDesignDrawingsResponse';

type Props = { manifold: DataForDesignDrawingsManifold };

export const HeatingStrategy = ({ manifold }: Props) => (
  <>
    {manifold.rooms &&
      manifold.rooms.map((room, index) => (
        <>
          <RoomNameText>{`${room.name} - Zone ${getZoneText(manifold.name, index + 1)}`}</RoomNameText>
          <br />
          {manifold.name} <br />
          {`Thermostat - ${room.thermostatTypeName}`} <br />
          {room.floorConstructionDescription} <br />
          {room.floorCoveringName} <br /> <br />
        </>
      ))}
  </>
);

const getZoneText = (manifoldName: string, index: number): string => {
  const manifoldRegex = new RegExp(/Manifold [A-Z0-9]/, 'i');
  const manifoldNameMatch = manifoldName.match(manifoldRegex);
  if (manifoldNameMatch) {
    const manifoldChar = manifoldNameMatch[0].charAt(manifoldNameMatch[0].length - 1);
    return `${manifoldChar}${index}`;
  }

  return `${manifoldName} ${index}`;
};

const RoomNameText = styled.span`
  font-weight: bold;
  color: ${colourPrimaryDarkPurple};
`;
